class NotificationsModalController {
    constructor($sce, $localStorage) {
        this.$onInit = () => {
            this.operationalNotifications = _.filter(this.resolve.notifications, notification => {
                var notificationType = notification.Type;
                if (notificationType === "Operational") {
                    return notification;
                }
            });
            this.systemNotifications = _.filter(this.resolve.notifications, notification => {
                var notificationType = notification.Type;
                if (notificationType === "SystemAlert") {
                    return notification;
                }
            });
        };
        this.closeDialog = () => {
            const today = new Date();
            this.localStorage.NotificationAcknowledged = today;
            this.dismiss();
        };
        this.sceService = $sce;
        this.localStorage = $localStorage;
    }
}
angular.module('app').component('notificationsModal', {
    bindings: {
        resolve: '<', // INotificationsResolve
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/Notifications/notifications-modal.tpl.html',
    controllerAs: 'vm',
    controller: NotificationsModalController
});
